<dx-popover
  [(visible)]="this.visible"
  [width]="200"
  [showTitle]="true"
  title="Select Underlying"
  [position]="{ my: 'center', at: 'center', of: window }"
  (onHidden)="this.onHidden()"
>
  <div *dxTemplate="let data of 'content'">
    <div class="underlying-list">
      <div *ngFor="let item of this.underlyings"
           class="underlying-item"
           (click)="this.onItemSelected(item)">
        {{ item.displayName }}
      </div>
    </div>
  </div>
</dx-popover>
